module.exports = __webpack_public_path__ + "media/images/shapes/curves/curve-1-7f34485def89de5bea2f97b7e27e66ba1de695c1424db2f5c30cb349d31002e3.svg";